import React from "react";
import { useUser } from "../UserContext";
import { useNavigate } from "react-router-dom";
import { Dropdown, Button } from "react-bootstrap";
import 'bootstrap-icons/font/bootstrap-icons.css';

const UserMenu = ({ handleLogout }) => {
    const { user } = useUser();
    // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const navigate = useNavigate();

    const handleProfileClick = () => {
        navigate('/profile');
    };

    if (!user) {
        return (
            <div className="user-menu">
                <Button variant="primary" onClick={() => navigate('/login')}>Login</Button>
            </div>
        );
    }

    return (
        <div className="user-menu">
            <Dropdown align="end">
                <Dropdown.Toggle variant="link" id="dropdown-user-menu" className="d-flex align-items-center">
                    <i className="bi bi-person-circle me-2" style={{ fontSize: '1.5rem' }}></i>
                    {/*<Image src="https://via.placeholder.com/30" roundedCircle alt="User Icon" className="me-2" />*/}
                    <span>{user.username}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown-menu" variant="light">
                    <Dropdown.Item onClick={handleProfileClick}>Profile</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default UserMenu;